// removed by extract-text-webpack-plugin
module.exports = {"card":"styles__card___1SS03","name":"styles__name___1L3GB","icon":"styles__icon___3I_zm"};


//////////////////
// WEBPACK FOOTER
// ./src/views/search/log-card/styles.css
// module id = 1145
// module chunks = 0